import { __module as t } from "../../../_virtual/isIPRange.js";
import { a as e } from "./util/assertString.js";
import { i as r } from "./isIP.js";
!function (t, a) {
  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = function (t) {
    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
    (0, s.default)(t);
    var r = t.split("/");
    if (2 !== r.length || !l.test(r[1]) || r[1].length > 1 && r[1].startsWith("0") || !(0, u.default)(r[0], e)) return !1;
    var a = null;
    switch (String(e)) {
      case "4":
        a = 32;
        break;
      case "6":
        a = 128;
        break;
      default:
        a = (0, u.default)(r[0], "6") ? 128 : 32;
    }
    return r[1] <= a && r[1] >= 0;
  };
  var s = i(e),
    u = i(r);
  function i(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }
  var l = /^\d{1,3}$/;
  t.exports = a.default, t.exports.default = a.default;
}(t, t.exports);
var a = t.exports;
export { a as i };